import { Button } from 'antd';
import styled from 'styled-components';

export const Label = styled.div`
  font-weight: 500;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  .ant-btn-text:not(.ant-btn-dangerous):not(.ant-input-search-button):hover {
    background: ${({ theme }) => theme.colors.red7} !important;
  }
`;

export const StyledButton = styled(Button)`
  padding: 8px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.red7};
`;
